import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, ErrorMessage } from '../../../components';
import { WithdrawalService } from '../../../services/WithdrawalService';
import DataTable from 'react-data-table-component';
import { DepositService } from '../../../services/DepositService';

export class UnipaymentWithdrawal extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            loading: true,
            confirm: false,
            showForm: false,
            refundableInvoices: [],
            selectedInvoice: null,
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            transactionId: "",
            validation: {
                error: false,
                success: false,
                message: ""
            }
        }
    }

    componentWillMount() {
        // Fetch refundable invoices
        DepositService.getRefundInvoices().then(response => {

            if (!response || !Array.isArray(response)) {
                this.setState({
                    loading: false,
                    validation: {
                        error: true,
                        message: response.message || 'Failed to fetch refundable invoices'
                    }
                });
                return;
            }
            this.setState({
                refundableInvoices: response || [],
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false,
                validation: {
                    error: true,
                    message: 'Network error while fetching invoices'
                }
            });
        });
    }

    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active
        });
    }

    selectInvoice(invoice) {
        // Set selected invoice and populate form fields
        this.setState({
            selectedInvoice: invoice,
            transactionId: invoice.transaction_id || invoice.transactionId || '',
            amount: invoice.price_amount || invoice.amount || 0,
            currency: invoice.price_currency || invoice.currency || 'USD',
            login: invoice.login || this.state.login,
            invoiceId: invoice.invoiceId,
            showForm: false
        });
    }

    proceedWithRefund() {
        if (!this.state.selectedInvoice) {
            this.setState({
                validation: {
                    error: true,
                    message: 'Please select an invoice to refund'
                }
            });
            return;
        }
        this.setState({ showForm: true });
    }

    onToggleWithdrawal() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm,
                showForm: prevState.confirm ? true : prevState.showForm
            }));
    }

    isValid() {
        if (!this.state.confirm) {

            if (!this.state.selectedInvoice) {
                this.setState({
                    validation: {
                        error: true,
                        message: 'Please select an invoice to refund'
                    }
                });
                return false;
            }

            let error = Validator.Valid({
                amount: this.state.amount,
                transactionId: this.state.transactionId
            }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;
    }

    onConfirmWithdrawal() {
        this.setState({ loading: true }, () => {
            WithdrawalService.Unipayment({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency,
                transactionId: this.state.transactionId,
                invoiceId: this.state.invoiceId,
            }).then((response) => {

                if (!response || response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        },
                        loading: false,
                        confirm: false
                    });
                } else {
                    // Success - show success message and refresh
                    this.setState({
                        loading: false,
                        confirm: false,
                        showForm: false,
                        validation: {
                            error: false,
                            success: true,
                            message: 'Refund request submitted successfully! We have sent a verification email to confirm your withdrawal request. Please check your email.'
                        }
                    }, () => {

                        setTimeout(() => {
                            window.location.href = '/withdrawal';
                        }, 10000);
                    });
                }

            }).catch(() => {
                this.setState({
                    validation: {
                        error: true,
                        message: 'Network error occurred'
                    },
                    loading: false,
                    confirm: false,
                    showForm: false
                });
            });

        });
    }

    formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleString();
        } catch (e) {
            return dateString;
        }
    }

    getStatusBadge(status) {
        const statusMap = {
            'Paid': 'success',
            'Confirmed': 'success',
            'Complete': 'success',
            'New': 'info',
            'Expired': 'danger',
            'Invalid': 'danger'
        };
        return statusMap[status] || 'secondary';
    }

    render() {
        const columns = [
            {
                name: Translate('Select'),
                cell: row => (
                    <input
                        type="radio"
                        name="invoiceSelection"
                        checked={this.state.selectedInvoice && this.state.selectedInvoice.invoice_id === row.invoice_id}
                        onChange={() => this.selectInvoice(row)}
                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    />
                ),
                width: '80px',
                center: true
            },
            {
                name: Translate('Amount'),
                cell: row => `${row.amount} ${row.currency}`,
                sortable: true,
            },
            {
                name: Translate('Status'),
                cell: row => (
                    <span
                        className={`badge badge-${this.getStatusBadge(row.status)}`}
                    >
                        {Translate(row.status)}
                    </span>
                ),
                sortable: true,
            },
            {
                name: Translate('Date'),
                cell: row => row.date,
                sortable: true,
            }
        ];

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb
                            Title={Translate("Unipayment Refund")}
                            Name={Translate("Credit Card Refund")}
                            SubTitle={Translate("Withdrawal")}
                            SubUrl="/withdrawal"
                        />
                        <Card
                            Title={Translate("Unipayment - Credit Card Refund")}
                            Description={Translate("Select a paid invoice to request a refund to your credit card")}
                        >
                            <div className="row">
                                <ErrorMessage Validation={this.state.validation} />
                                
                                {/* Success Message */}
                                {this.state.validation.success && (
                                    <div className="col-md-12">
                                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <h4 className="alert-heading">
                                                <i className="fas fa-check-circle"></i> {Translate("Success!")}
                                            </h4>
                                            <p className="mb-0">{this.state.validation.message}</p>
                                            <hr />
                                            <p className="mb-0 mt-2">
                                                <i className="fas fa-info-circle"></i> {Translate("Redirecting to withdrawal page in 10 seconds...")}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/* Invoice Selection Table */}
                                <div className="col-md-12">
                                    <h4 className="mt-0 header-title m-b-20 mt-4 text-dark">
                                        <i className="fas fa-file-invoice-dollar"></i>{Translate("  Refundable Invoices")}
                                    </h4>

                                    {this.state.refundableInvoices.length === 0 ? (
                                        <div className="alert alert-info" role="alert">
                                            <strong><i className="fas fa-info-circle"></i> {Translate("No Refundable Invoices")}</strong>
                                            <p className="mb-0">{Translate("You don't have any paid invoices eligible for refund at this time.")}</p>
                                        </div>
                                    ) : (
                                        <>
                                            <DataTable
                                                columns={columns}
                                                data={this.state.refundableInvoices}
                                                pagination
                                                highlightOnHover
                                                striped
                                                noHeader
                                                onRowClicked={(row) => this.selectInvoice(row)}
                                            />
                                            <div className="mt-3 mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg btn-primary"
                                                    onClick={() => this.proceedWithRefund()}
                                                    disabled={!this.state.selectedInvoice}
                                                >
                                                    <i className="fas fa-arrow-right"></i> {Translate("Proceed with Selected Invoice")}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>

                                {/* Withdrawal Form - Only show if showForm is true */}
                                {this.state.showForm && !this.state.confirm && (
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="withdrawalForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark">
                                                <i className="fas fa-file-invoice"></i>{Translate("  Refund Details")}
                                            </h4>

                                            {/* Selected Invoice Info */}
                                            <div className="alert alert-success" role="alert">
                                                <h5 className="alert-heading">
                                                    <i className="fas fa-check-circle"></i> {Translate("Selected Invoice")}
                                                </h5>
                                                <p className="mb-0">
                                                    <strong>{Translate("Amount")}:</strong> {this.state.selectedInvoice.amount} {this.state.selectedInvoice.currency}
                                                </p>
                                            </div>

                                            <div className="form-group row ml-3">
                                                <label htmlFor="account" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                                <div className="col-sm-5">
                                                    <b className="bold"> {this.state.login}</b>
                                                </div>
                                            </div>

                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        id="amount"
                                                        value={this.state.amount}
                                                        readOnly
                                                        disabled
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        id="currency"
                                                        value={this.state.currency}
                                                        readOnly
                                                        disabled
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row ml-3">
                                                <label htmlFor="transactionId" className="col-sm-2 col-form-label">{Translate("Transaction ID")}</label>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        id="transactionId"
                                                        value={this.state.transactionId}
                                                        readOnly
                                                        disabled
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row ml-3">
                                                <label className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button
                                                        type="button"
                                                        className="btn btn-lg btn-warning"
                                                        onClick={(e) => this.onToggleWithdrawal()}
                                                    >
                                                        <i className="fas fa-undo"></i> {Translate("Request Refund")}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )}

                                {/* Confirmation */}
                                {this.state.confirm && (
                                    <div className="col-md-12">
                                        <div className="card border-warning">
                                            <div className="card-header bg-warning text-white">
                                                <h5 className="mb-0">
                                                    <i className="fas fa-exclamation-triangle"></i> {Translate("Confirm Refund Request")}
                                                </h5>
                                            </div>
                                            <div className="card-body">
                                                <h5>{Translate("Please confirm your refund details:")}</h5>
                                                <table className="table table-bordered mt-3">
                                                    <tbody>
                                                        <tr>
                                                            <th style={{ width: '30%' }}>{Translate("Account")}</th>
                                                            <td>{this.state.login}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{Translate("Amount")}</th>
                                                            <td>{this.state.amount} {this.state.currency}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{Translate("Transaction ID")}</th>
                                                            <td>{this.state.transactionId}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="mt-4">
                                                    <button
                                                        type="button"
                                                        className="btn btn-lg btn-secondary mr-3"
                                                        onClick={(e) => this.onToggleWithdrawal()}
                                                    >
                                                        <i className="fas fa-times"></i> {Translate("Cancel")}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-lg btn-success"
                                                        onClick={(e) => this.onConfirmWithdrawal()}
                                                    >
                                                        <i className="fas fa-check"></i> {Translate("Confirm Refund")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}
